export default "__VITE_ASSET__b99afa2e__"